module.exports = __webpack_public_path__ + "static/media/profile-picture-727w.fb880d25.jpg";